import type { SessionView } from '~/helpers/learner/session-view'
import { Download, Loader } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Button } from '~/components/ui/button'
import { canDownloadCertificate } from '~/helpers/learner/certificate-notice'
import ProfileSection from './ProfileSection'

type ProfileCertificatesProps = {
  sessions: SessionView[]
  onDownload: (sessionId: string) => void
  downloadingId?: string | null
}

/** Les attestations que l'apprenant a obtenues, téléchargeables (#242). C'est l'API qui dit lesquelles. */
function ProfileCertificates({ sessions, onDownload, downloadingId }: ProfileCertificatesProps) {
  const { t } = useTranslation()
  const available = sessions.filter(canDownloadCertificate)

  return (
    <ProfileSection title={t('profile.certificates.title')} anchor="profile.certificates">
      {available.length === 0
        ? <p className="text-sm text-muted-foreground">{t('profile.certificates.empty')}</p>
        : (
            <ul className="flex flex-col divide-y divide-border">
              {available.map(session => (
                <li key={session.id} className="flex items-center justify-between gap-3 py-2">
                  <span className="font-medium">{session.name}</span>
                  <Button
                    variant="outline"
                    size="sm"
                    disabled={downloadingId === session.id}
                    onClick={() => onDownload(session.id)}
                    aria-label={t('profile.certificates.downloadFor', { name: session.name })}
                  >
                    {downloadingId === session.id
                      ? <Loader className="mr-2 size-4 animate-spin" aria-hidden />
                      : <Download className="mr-2 size-4" aria-hidden />}
                    {t('profile.certificates.download')}
                  </Button>
                </li>
              ))}
            </ul>
          )}
    </ProfileSection>
  )
}

export default ProfileCertificates
